module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header-content"
  }, [_c('ul', {
    staticClass: "v-breadcrumbs"
  }, _vm._l((_vm.breadcrumbItems), function(item, index) {
    return _c('span', [_c('li', [(item.to) ? _c('router-link', {
      attrs: {
        "to": {
          name: item.to,
          params: item.params
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (!item.to) ? _c('span', {
      staticClass: "breadcrumbs-simple"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1), _vm._v(" "), (index < (_vm.breadcrumbItems.length - 1)) ? _c('li', {
      staticClass: "v-breadcrumbs__divider"
    }, [_vm._v("/")]) : _vm._e()])
  }), 0), _vm._v(" "), _c('h2', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.tituloPagina))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e16df81!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/main/PageHeader.vue
// module id = 533
// module chunks = 2